import { Container, SectionText } from '@/atoms';
import { ContactForm as ContactFormBase } from '@/organisms';

import type { FunctionComponent } from 'react';
// import { ContactForm as Form } from '@/organisms';
import type { TypeContactFormProps } from './types';

/**
 * ContactForm
 */
export const ContactForm: FunctionComponent<TypeContactFormProps> = ({
  className = '',
  caption,
  formValues,
  title,
  landing,
  background,
  desc,
  index,
  textColor,
  id,
}: TypeContactFormProps) => (
  <>
    <style scoped>
      {`
    .backimage {
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), url(${background.backgroundImageMobile});
      background-size: cover ;
          
    }
  
  @media (min-width: 750px) {
    .backimage {
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), url(${background.backgroundImage}) !important;
      background-size: cover !important;
    }
  }`}
    </style>
    <div className="backimage">
      <Container
        id={id}
        index={index}
        backgroundColorBottom={background.backgroundColorBottom}
        backgroundColorTop={background.backgroundColorTop}
        backgroundColorBottomMobile={background.backgroundColorBottomMobile}
        backgroundColorTopMobile={background.backgroundColorTopMobile}
        cutLevel={background.cutLevel}
        cutLevelMobile={background.cutLevelMobile}
        hasCutLevel={background.hasCutLevel}
        className={`!py-14  lg:!py-20 ${
          landing
            ? 'flex w-full  !max-w-none flex-col !py-4 md:!py-20 md:pr-4 lg:flex-row'
            : 'flex flex-col gap-5'
        } ${className}`}
      >
        <SectionText
          direction="column"
          textAlign={landing ? 'start' : 'center'}
          textAlignMobile="start"
          variant={textColor}
          caption={caption}
          title={title}
          className={`${
            landing
              ? 'w-full justify-center p-16 lg:[&>div>div>h2]:text-heading--h1 lg:w-3/5'
              : 'items-center'
          }`}
          desc={desc}
        />
        <ContactFormBase {...formValues} landing={landing} />
      </Container>
    </div>
  </>
);

ContactForm.displayName = 'ContactForm';
